import { Button } from "../ui/button";
import { Download } from "lucide-react";
import { P } from "./report-utils";

export function ReportHeader({ rUser, coach, onExportPDF }) {
    const coachName = coach?.branding_display_name || coach?.name || "";
    const coachLogo = coach?.branding_logo_url || "";
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

    return (
        <div className="rounded-b-2xl overflow-hidden shadow-sm mx-3 sm:mx-5 lg:mx-7" style={{ background: P.navy }}>
            <div className="px-5 sm:px-8 py-5 sm:py-6 flex items-center gap-4">
                {coachLogo ? (
                    <div className="w-12 h-12 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center overflow-hidden flex-shrink-0 border border-white/10">
                        <img src={`${backendUrl}${coachLogo}`} alt="" className="max-w-full max-h-full object-contain" />
                    </div>
                ) : null}
                <div className="flex-1 min-w-0">
                    <p className="text-[0.65rem] font-bold uppercase tracking-[0.2em] text-white/40 mb-1">Executive Diagnostic</p>
                    <h1 className="text-white text-lg sm:text-xl font-semibold truncate" style={{ fontFamily: "Outfit" }}>
                        Coachability Assessment Report
                    </h1>
                    {coachName && <p className="text-white/50 text-xs mt-0.5">{coachName}</p>}
                </div>
                <Button data-testid="export-pdf-btn" onClick={onExportPDF}
                    className="gap-2 text-xs font-semibold bg-white/10 hover:bg-white/20 text-white border border-white/10 rounded-lg px-4 py-2.5 flex-shrink-0">
                    <Download className="h-3.5 w-3.5" /> Export PDF
                </Button>
            </div>
            <div className="px-5 sm:px-8 py-3 flex flex-wrap gap-x-5 gap-y-1 text-[0.7rem] text-white/35 border-t border-white/5" style={{ fontFamily: "Manrope" }}>
                <span className="font-semibold text-white/70">{rUser?.name}</span>
                {rUser?.designation && <span>{rUser.designation}</span>}
                {rUser?.organization && <span>{rUser.organization}</span>}
            </div>
        </div>
    );
}
